export function shouldIncludeOnboardingNavItem(
    isAthleteUser: boolean,
    isAdminViewingAthlete: boolean,
    showOnboardingNav: boolean,
): boolean {
    return !isAthleteUser || isAdminViewingAthlete || showOnboardingNav;
}
